function UnsubscribeEdmService(restangular) {
    this._api = restangular.one('shopper');
}

UnsubscribeEdmService.prototype.unsubscribeEDM = function (shopperid, checksum, documentid) {
    return this._api.one('unsubscribeEdm').get({ shopperId: shopperid, checksum, documentId: documentid });
};

UnsubscribeEdmService.prototype.unsubscribeEDMConfirmation = function (unsubscribeData) {
    return this._api.one('UnsubscribeEDMConfirmation').doPOST(unsubscribeData);
};


module.exports = UnsubscribeEdmService;



// WEBPACK FOOTER //
// ./src/common/unsubscribeedm/unsubscribe-edm.service.js